// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"32cefd7c","239":"c6dffee5","453":"2c4a4d59","745":"14476bf3"}[chunkId] + ".chunk.js";
};